// extracted by mini-css-extract-plugin
export default {"newGameBtn":"NewGameBtn_newGameBtn__0F2QP","appear":"NewGameBtn_appear__em5rV"};